<div class="wrapper">
  <div class="name profile-menu-item">
    <orbit-fa-icon [iconName]="faUser" />
    <span>{{ name() }}</span>
  </div>
  <div class="email profile-menu-item">
    <orbit-fa-icon [iconName]="faEnvelope" />
    <span>{{ email() }}</span>
  </div>
</div>

<div class="button-wrapper">
  <orbit-button [label]="resetPasswordButtonLabel()" (buttonClick)="resetPasswordClicked()" />
  <orbit-button [label]="logoutButtonLabel()" (buttonClick)="logoutClicked()" />
</div>

<orbit-fa-icon class="bubbleArrow" [iconName]="bubbleArrow" />
